import { CommonModalContext, useCommonModal } from './context';

import { CommonModal } from './CommonModal';

export default CommonModal;

export { CommonModalContext, useCommonModal };
